import isEmpty from 'lodash/isEmpty';
import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { Elements } from 'react-stripe-elements';
import { createStructuredSelector } from 'reselect';
import {
  closeModal,
  hideLoadingFullScreen,
  initPollingPaymentIntentStatus,
  showLoadingFullScreenCard,
  showLoadingFullScreenWeChat,
  stopPollingPaymentIntentStatus,
  upgradePremiumWithCredit,
  upgradeSinglePremiumWithCard,
  updateCountdown,
} from './actions';
import PaymentForm from './PaymentForm';
import PaymentSingleForm from './PaymentSingleForm';
import {
  makeSelectModal,
  makeSelectPaymentIntentOfSinglePremium,
  makeSelectPrices,
  makeSelectPriceSelected,
  makeSelectSinglePricePremiums,
  makeSelectSinglePricePremiumSelected,
  // makeSelectCountdownDiscount,
  // makeSelectCoupon,
  // makeSelectDiscountCoupon,
  // makeSelectDiscountRemainingDuration,
  makeSelectIsCountdownActive,
} from './selectors';
import { updateProfile } from '../AuthProvider/actions';
import { makeSelectCurrentLanguage } from '../Language/selectors';
import withI18next from '~/../hocs/_withI18next';
import PremiumPlanBox from '~/components/RegisterPremium/PremiumPlanBox';
import SinglePricePremiumPlanBox from '~/components/RegisterPremium/SinglePricePremiumPlanBox';
import Config from '~/config';
import { showError } from '~/containers/CustomErrorMessage/actions';

@withI18next()
class PaymentModal extends React.Component {
  handleClose = () => {
    this.props.closeModal();
  };

  handleSubmit = (response) => {
    const {
      upgradePremiumWithCredit,
      prices,
      priceSelected,
      currentLanguage,
      // countdown,
      // discountCoupon,
      // discountRemainingDuration,
      isCountdownActive,
      stripe,
    } = this.props;

    let isDiscounted;
    if (prices[priceSelected].plan === 'MONTHLY') {
      isDiscounted = false;
    } else {
      // isDiscounted = discountRemainingDuration > 0;
      isDiscounted = isCountdownActive;
    }
    console.log('isDiscountedddddddddddd', isDiscounted);

    const currentPlan = prices[`${priceSelected}`].pricesByCurrency.filter(
      (plan) => plan.lang == currentLanguage,
    )[0];
    console.log('currentPlannnnnnn', currentPlan);
    upgradePremiumWithCredit({
      stripeToken: response.payload.token.id,
      idempotencyToken: response.idempotencyToken,
      plan: prices[priceSelected].plan,
      lang: currentLanguage,
      currency: currentPlan.currency,
      planId: currentPlan.planId,
      // isDiscounted: false,
      isDiscounted: isDiscounted,
      stripe: response.stripe || stripe,
    });
  };

  handleSubmitSinglePayment = (response) => {
    const {
      upgradePremiumWithCredit,
      prices,
      priceSelected,
      currentLanguage,
    } = this.props;
    console.log('--- CHECK SUBMIT ---');
    console.log(response);
    console.log('--- CHECK SUBMIT ---');
    // const card =
    // upgradeSinglePremiumWithCard({
    //   stripeToken: response.payload.token.id,
    //   idempotencyToken: response.idempotencyToken,
    //   plan: prices[priceSelected].plan,
    //   lang: currentLanguage,
    //   currency: currentPlan.currency,
    //   planId: currentPlan.planId,
    // });
  };

  renderPremiumPlanBox = () => {
    const {
      t,
      priceSelected,
      prices,
      currentLanguage,
      // countdown,
      // discountCoupon,
      // coupon,
      updateCountdown,
    } = this.props;
    let selectedPlan = prices[priceSelected].pricesByCurrency.filter(
      (pr) => pr.lang == currentLanguage,
    )[0];
    selectedPlan =
      selectedPlan ||
      prices[priceSelected].pricesByCurrency.filter((pr) => pr.lang == 'en')[0];

    return (
      <PremiumPlanBox
        currentPlan={selectedPlan}
        typePlan={priceSelected}
        t={t}
        displayAtPaymentModal
        // countdown={countdown}
        // coupon={discountCoupon}
        updateCountdown={updateCountdown}
      />
    );
  };

  renderSinglePremiumPlanBox = () => {
    const { t, selectedSinglePricePremium } = this.props;
    return (
      <SinglePricePremiumPlanBox
        currentSinglePremium={selectedSinglePricePremium}
        t={t}
        displayAtPaymentModal
      />
    );
  };

  renderPremiumBoxByCurrentRegion = () => {
    if (Config.isChina()) {
      return this.renderSinglePremiumPlanBox();
    }
    return this.renderPremiumPlanBox();
  };

  renderPremiumPaymentFormByCurrentRegion = () => {
    const {
      priceSelected,
      selectedSinglePricePremium,
      prices,
      singlePricePremiums,
      currentPaymentIntent,
      showLoadingFullScreenCard,
      showLoadingFullScreenWeChat,
      hideLoadingFullScreen,
      closeModal,
      showError,
      initPollingPaymentIntentStatus,
      stopPollingPaymentIntentStatus,
      updateProfile,
    } = this.props;

    if (Config.isChina()) {
      return (
        <Elements>
          <PaymentSingleForm
            disable={
              !selectedSinglePricePremium || isEmpty(singlePricePremiums)
            }
            onSubmit={this.handleSubmitSinglePayment}
            paymentIntent={currentPaymentIntent}
            showLoadingFullScreenWeChat={showLoadingFullScreenWeChat}
            showLoadingFullScreenCard={showLoadingFullScreenCard}
            hideLoadingFullScreen={hideLoadingFullScreen}
            showError={showError}
            closeModal={closeModal}
            initPollingPaymentIntentStatus={initPollingPaymentIntentStatus}
            stopPollingPaymentIntentStatus={stopPollingPaymentIntentStatus}
            updateProfile={updateProfile}
          />
        </Elements>
      );
    }

    return (
      <Elements>
        <PaymentForm
          disable={!priceSelected || isEmpty(prices)}
          onSubmit={this.handleSubmit}
          typePlan={priceSelected}
        />
      </Elements>
    );
  };

  render() {
    const { modal, t } = this.props;

    return (
      <Modal
        show={modal}
        onHide={this.handleClose}
        className="member-login-modal"
      >
        <Modal.Body className="responsive-login-modal">
          <div className="ac-dialog login-modal">
            <div className={`dialog-header ${Config.serviceType}`}>
              {t('modal_payment_header')}
            </div>
            <div
              className="dialog-body"
              style={{
                padding: '10px 12px',
              }}
            >
              <div className="padding-10">
                {this.renderPremiumBoxByCurrentRegion()}
              </div>
              {this.renderPremiumPaymentFormByCurrentRegion()}
            </div>
          </div>
        </Modal.Body>
        <style jsx global>
          {`
            .payment-modal .social-section {
              background: #ffffff;
              text-align: center;
            }

            .payment-modal .login-section {
              padding: 20px 55px 30px;
            }

            .btn-payment {
              width: 220px;
              margin: auto;
              text-align: center;
            }

            @media (max-width: 768px) {
              .payment-modal .ac-dialog {
                width: calc(100% - 20px);
                margin-left: 10px;
                margin-right: 10px;
              }
            }

            .responsive-login-modal {
              text-align: center;
            }

            .register-premium-form .secure-notes {
              padding: 30px 10px;
              text-align: left;
              list-style: none;
            }
            .register-premium-form .secure-notes .secure-note-item {
              margin-top: 7px;
            }
            .register-premium-form .secure-notes .secure-note-item:before {
              content: '🔏';
            }

            .modal-content {
              background-color: transparent;
            }
          `}
        </style>
      </Modal>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  modal: makeSelectModal(),
  prices: makeSelectPrices(),
  singlePricePremiums: makeSelectSinglePricePremiums(),
  priceSelected: makeSelectPriceSelected(),
  selectedSinglePricePremium: makeSelectSinglePricePremiumSelected(),
  currentLanguage: makeSelectCurrentLanguage(),
  currentPaymentIntent: makeSelectPaymentIntentOfSinglePremium(),
  // countdown: makeSelectCountdownDiscount(),
  // discountCoupon: makeSelectDiscountCoupon(),
  // discountRemainingDuration: makeSelectDiscountRemainingDuration(),
  isCountdownActive: makeSelectIsCountdownActive(),
  // coupon: makeSelectCoupon(),
});
const mapDispatchToProps = (dispatch) => ({
  upgradePremiumWithCredit: (params) =>
    dispatch(upgradePremiumWithCredit(params)),
  upgradeSinglePremiumWithCard: (params) =>
    dispatch(upgradeSinglePremiumWithCard(params)),
  closeModal: () => dispatch(closeModal()),
  showLoadingFullScreenWeChat: (wechat) =>
    dispatch(showLoadingFullScreenWeChat(wechat)),
  showLoadingFullScreenCard: () => dispatch(showLoadingFullScreenCard()),
  hideLoadingFullScreen: () => dispatch(hideLoadingFullScreen()),
  showError: (params) => dispatch(showError(params)),
  initPollingPaymentIntentStatus: (params) =>
    dispatch(initPollingPaymentIntentStatus(params)),
  stopPollingPaymentIntentStatus: () =>
    dispatch(stopPollingPaymentIntentStatus()),
  updateProfile: (params) => dispatch(updateProfile(params)),
  updateCountdown: (remainingDuration) =>
    dispatch(updateCountdown(remainingDuration)),
});
export default connect(mapStateToProps, mapDispatchToProps)(PaymentModal);
